/**
 * Blog Category Rows - JavaScript
 * Swiper initialization for horizontal category row carousels
 * Pattern aligned with blog-carousel.js
 */

(function() {
  'use strict';

  var swiperInstances = new Map();

  function updateNavVisibility(swiperInstance, carouselElement, totalSlides) {
    var prevBtn = carouselElement.querySelector('.swiper-button-prev');
    var nextBtn = carouselElement.querySelector('.swiper-button-next');

    if (!prevBtn || !nextBtn || !swiperInstance) return;

    var currentSlidesPerView = swiperInstance.params.slidesPerView;

    if (totalSlides <= Math.floor(currentSlidesPerView)) {
      prevBtn.style.setProperty('display', 'none', 'important');
      nextBtn.style.setProperty('display', 'none', 'important');
    } else {
      prevBtn.style.removeProperty('display');
      nextBtn.style.removeProperty('display');
    }
  }

  function initCategoryRowCarousel(carouselElement, sectionId) {
    var blockId = carouselElement.dataset.blockId;
    var carouselKey = sectionId + '-category-row-' + blockId;

    if (swiperInstances.has(carouselKey)) {
      return swiperInstances.get(carouselKey);
    }

    if (typeof Swiper === 'undefined') {
      return null;
    }

    var totalSlides = carouselElement.querySelectorAll('.swiper-slide').length;

    var swiperConfig = {
      breakpoints: {
        320: {
          slidesPerView: 1.15,
          slidesPerGroup: 1,
          spaceBetween: 16,
          centeredSlides: false
        },
        768: {
          slidesPerView: 2.2,
          slidesPerGroup: 2,
          spaceBetween: 16,
          centeredSlides: false
        },
        900: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
          centeredSlides: false
        }
      },
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      resistance: true,
      resistanceRatio: 0.85,
      threshold: 5,
      followFinger: true,
      shortSwipes: true,
      longSwipes: true,
      touchEventsTarget: 'container',
      centeredSlides: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      navigation: {
        nextEl: carouselElement.querySelector('.swiper-button-next'),
        prevEl: carouselElement.querySelector('.swiper-button-prev')
      },
      speed: 600,
      cssMode: false,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous article',
        nextSlideMessage: 'Next article'
      },
      on: {
        init: function() {
          updateNavVisibility(this, carouselElement, totalSlides);
        },
        breakpoint: function() {
          updateNavVisibility(this, carouselElement, totalSlides);
        },
        resize: function() {
          updateNavVisibility(this, carouselElement, totalSlides);
        }
      }
    };

    var rowSwiper = new Swiper(carouselElement, swiperConfig);
    swiperInstances.set(carouselKey, rowSwiper);
    carouselElement._categoryRowInitialized = true;

    return rowSwiper;
  }

  function initBlogCategoryRows(sectionElement) {
    var sectionId = sectionElement.dataset.sectionId;
    var carousels = sectionElement.querySelectorAll('[data-blog-category-rows-swiper]');

    carousels.forEach(function(carouselElement) {
      if (carouselElement._categoryRowInitialized) {
        return;
      }
      initCategoryRowCarousel(carouselElement, sectionId);
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-section-type="blog-category-rows"]');
    sections.forEach(function(section) {
      initBlogCategoryRows(section);
    });
  }

  function destroyCarousel(carouselElement, sectionId) {
    var blockId = carouselElement.dataset.blockId;
    var carouselKey = sectionId + '-category-row-' + blockId;

    if (swiperInstances.has(carouselKey)) {
      swiperInstances.get(carouselKey).destroy(true, false);
      swiperInstances.delete(carouselKey);
      carouselElement._categoryRowInitialized = false;
    }
  }

  function cleanupSection(sectionElement) {
    var sectionId = sectionElement.dataset.sectionId;
    var carousels = sectionElement.querySelectorAll('[data-blog-category-rows-swiper]');

    carousels.forEach(function(carouselElement) {
      destroyCarousel(carouselElement, sectionId);
    });
  }

  function cleanupAll() {
    swiperInstances.forEach(function(swiper) {
      swiper.destroy(true, false);
    });
    swiperInstances.clear();

    document.querySelectorAll('[data-blog-category-rows-swiper]').forEach(function(carouselElement) {
      carouselElement._categoryRowInitialized = false;
    });
  }

  function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var attempts = 0;
    var interval = setInterval(function() {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(interval);
        callback();
      } else if (attempts >= 50) {
        clearInterval(interval);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      waitForSwiper(initAll);
    });
  } else {
    waitForSwiper(initAll);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('[data-section-type="blog-category-rows"]');
      if (section) {
        waitForSwiper(function() {
          initBlogCategoryRows(section);
        });
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target.querySelector('[data-section-type="blog-category-rows"]');
      if (section) {
        cleanupSection(section);
      }
    });

    document.addEventListener('shopify:section:reorder', function() {
      cleanupAll();
      waitForSwiper(initAll);
    });
  }

  var resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      swiperInstances.forEach(function(swiper) {
        if (swiper && swiper.update) {
          swiper.update();
        }
      });
    }, 250);
  });

  window.addEventListener('beforeunload', cleanupAll);
})();
